import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  getFirstAccessibleTenantPath,
  isRouteAllowed,
  matchRoutePermission,
} from "../../config/routePermissions";
import { usePermission } from "../../hooks/usePermission";

/**
 * Gates the current route using `matchRoutePermission` + `can(module, action)`.
 * Must render inside `Router` and `PermissionProvider` (typically nested under `PrivateRoute`).
 */
export function PermissionRoute({ children }) {
  const location = useLocation();
  const { can, canAny, loading, bypass, summary } = usePermission();

  const { module, action, anyOf } = matchRoutePermission(location.pathname);
  const isPublicRoute =
    module == null && action == null && !(anyOf && anyOf.length);

  if (isPublicRoute) {
    return children;
  }

  if (loading && !bypass) {
    return null;
  }

  if (!isRouteAllowed(location.pathname, can, canAny)) {
    let next = getFirstAccessibleTenantPath(summary);
    if (next === location.pathname) {
      next = "/profile";
    }
    return <Navigate to={next} replace state={{ from: location.pathname }} />;
  }

  return children;
}
